import { useMutation } from '@tanstack/react-query';
import { getAll } from '../requests/importRule';

const KEY = 'importRule';

const useGetAllImportRules = () => useMutation({
  mutationKey: [KEY, 'getAll'],
  mutationFn: () => getAll(),
});

const importRuleMutation = {
  useGetAllImportRules,
};

export default importRuleMutation;
